import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InputRow from './InputRow'
import Loading from './Loading'
export default class Address extends Component {
  constructor (props) {
    super(props)
    this.state = {
      addressType: '',
      addressTypeData: [],
      addressLine1: this.props.line1 || '',
      addressLine2: this.props.line2 || '',
      selectedCountry: '',
      cityData: [],
      regionData: [],
      selectedCity: '',
      selectedRegion: '',
      loading: true,
      error: '',
      dormPlanInterest:this.props.dormPlanInterest || false
    }
    this.fetchCity = this.fetchCity.bind(this)
    //this.fetchRegion = this.fetchRegion.bind(this)
  }

  componentDidMount () {
   // const { selectedCity } = this.state
    fetch(`${process.env.REACT_APP_API_URL}/api/AddressInformation/GetAddressTypes`)
      .then(res => res.json())
      .then(res => {
        const selectedCountry = ''
        const selectedCity = ''
        this.setState({ addressTypeData: res, selectedCountry: this.props.country || selectedCountry })
        this.fetchCity(parseInt(this.props.country) || selectedCountry)
        this.fetchRegion(parseInt(this.props.city) || selectedCity)
        if (res) {
          const homeAddress = res.filter(ele => ele.value === 'Home Address')
          const homeAddressId = homeAddress && homeAddress.length > 0 ? homeAddress[0].Id : ''
          this.setState({ addressType: this.props.addressType || homeAddressId, loading: false })
          this.props.getDefaultValue('Add', this.props.addressType || homeAddressId)
        }
      })
      .catch(err => console.log(err))
  }

  async fetchCity (val) {
    var city = await fetch(`${process.env.REACT_APP_API_URL}/api/AddressInformation/GetCitiesByCountry?countryid=${val}`)
      .then(res => res.json())
      .then(res => {
        this.setState({ cityData: res })
        if (res.length) {
          this.setState({ selectedCity: this.props.city || '' })
          return ''
        }
      })
      .catch(err => console.log(err))
    return city
  }

  async fetchRegion (val) {
    var region = await fetch(`${process.env.REACT_APP_API_URL}/api/AddressInformation/GetProvinceByCity?cityId=${val}`)
      .then(res => res.json())
      .then(res => {
        this.setState({ regionData: res })
        if (res.length) {
          this.setState({ selectedRegion: this.props.region || '' })
          return ''
        }
      })
      .catch(err => console.log(err))
    return region
  }


  render () {
    const validationError = this.props.error
    const { loading, selectedCity, selectedRegion, addressType, addressLine1, addressLine2, selectedCountry, error, addressTypeData, cityData, regionData, dormPlanInterest } = this.state
    if (loading) {
      return (
        <Loading />
      )
    }
    return (
     
      <div>
        <p style={{ color: 'red' }}>{error}</p>
        <span className="hidden">
        <InputRow
          name="select"
          rowName="Address Type"
          required="*"
          errMsg={validationError.addressType ? validationError.addressType : ''}
          value={addressType}
          onChange={(val) => {
            this.setState({ addressType: val })
            this.props.collectState('Add', {
              addressType: val,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              selectedCountry: selectedCountry,
              selectedCity: selectedCity,
              selectedRegion: selectedRegion,
              dormPlanInterest:dormPlanInterest
            })
          }}
          data={addressTypeData}
        />
        </span>
        <InputRow
          rowName="Address Line 1"
          name="text"
          required="*"
          errMsg={validationError.addressLine1 ? validationError.addressLine1 : ''}
          value={addressLine1}
          onChange={(val) => {
            this.setState({ addressLine1: val })
            this.props.collectState('Add', {
              addressType: addressType,

              addressLine1: val,
              addressLine2: addressLine2,
   
              selectedCountry: selectedCountry,
              selectedCity: selectedCity,
              selectedRegion: selectedRegion,
              dormPlanInterest:dormPlanInterest
          
            })
          }}
        />
        <InputRow
          rowName="Address Line 2"
          name="text" 
          value={addressLine2}
          onChange={(val) => {
            this.setState({ addressLine2: val })
            this.props.collectState('Add', {
              addressType: addressType,
              addressLine1: addressLine1,
              addressLine2: val,
              selectedCountry: selectedCountry,
              selectedCity: selectedCity,
              selectedRegion: selectedRegion,
              dormPlanInterest:dormPlanInterest
         
            })
          }}
        /> 
        <InputRow
          rowName="Country"
          value={selectedCountry}
          name="select"
          data={this.props.countryData}
          onChange={async (val) => {
            this.setState({ selectedCountry: val })
            this.props.collectState('Add', {
              addressType: addressType,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              selectedCountry: val,
              selectedCity: '',
              dormPlanInterest:dormPlanInterest
            })
            await this.fetchCity(val)
            //this.fetchRegion(citys)
          }}
          required='*'
          errMsg={validationError.selectedCountry ? validationError.selectedCountry : ''}
        />
        <InputRow
          rowName="City"
          value={selectedCity}
          name="select"
          data={cityData}
          required="*"
          errMsg={validationError.selectedCity ? validationError.selectedCity : ''}
          onChange={ async (val) => {
            this.setState({ selectedCity: val })
            this.props.collectState('Add', {
              addressType: addressType,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              selectedCountry: selectedCountry,
              selectedCity: val,
              selectedRegion: '',
              dormPlanInterest:dormPlanInterest

            })
            //this.fetchRegion(val)
            await this.fetchRegion(val)
          }}
        />  

          <InputRow
          rowName="State"
          value={selectedRegion}
          name="select"
          data={regionData}
          required="*"
          errMsg={validationError.selectedRegion ? validationError.selectedRegion : ''}
          onChange={(val) => {
            this.setState({ selectedRegion: val })
            this.props.collectState('Add', {
              addressType: addressType,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              selectedCountry: selectedCountry,
              selectedCity: selectedCity,
              selectedRegion: val,
              dormPlanInterest:dormPlanInterest

            })
            //this.fetchRegion(val)
          }}
        />  

         <div className="illness-part">
          <p>For surveying purposes, please indicate if you are interested in University Dorms</p>
          Yes<input type="radio" value={dormPlanInterest} onChange={() => {
            this.setState({ dormPlanInterest: true })
            this.props.collectState('Add', {
              addressType: addressType,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              selectedCountry: selectedCountry,
              selectedCity: selectedCity,
              selectedRegion: selectedRegion,
              dormPlanInterest:true

            })
          }} name="dorm" checked={!!dormPlanInterest} style={{ minWidth: 'auto', marginLeft: 5 }}/>
          No<input type="radio" value={dormPlanInterest} onChange={() => {
            this.setState({ dormPlanInterest: false })
            this.props.collectState('Add', {
              addressType: addressType,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              selectedCountry: selectedCountry,
              selectedCity: selectedCity,
              selectedRegion: selectedRegion,
              dormPlanInterest:false

            })
          }} name="dorm" checked={!dormPlanInterest} style={{ minWidth: 'auto', marginLeft: 5 }}/>
        </div>    
        <button className="save" onClick={() => { this.props.onSave() }}>Next</button>

      </div>
    )
  }
}

Address.propTypes = {
  onSave: PropTypes.func.isRequired,
  countryData: PropTypes.array.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  addressType: PropTypes.number,
  line1: PropTypes.string,
  line2: PropTypes.string,
  line4: PropTypes.string,
  pincode: PropTypes.string,
  country: PropTypes.number,
  city: PropTypes.number,
  region: PropTypes.number,
  stateProvinceId: PropTypes.number,
  collectState: PropTypes.func,
  error: PropTypes.object,
  getDefaultValue: PropTypes.func
}
